var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('login-form',{attrs:{"title":"宋凰数字化运营系统"}})}
var staticRenderFns = []

export { render, staticRenderFns }